import { displayUserAvatar } from '../../Helpers/chatHelper/AvatarHelper';
import { ReactComponent as ProIcon } from "../../Assets/iconsv2/generic/PremiumUser.svg";
import { ReactComponent as PlatformIcon } from "../../Assets/iconsv2/generic/BusinessUser.svg";
import { ReactComponent as PlatformIconLight } from "../../Assets/iconsv2/generic/BusinessUserLight.svg";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import React, { Suspense, useState } from 'react';
import styled from 'styled-components';

import { ReactComponent as GenericAvatar } from '../../Assets/iconsv2/generic/GenericAvatar.svg'
import DeleteConfirmationChild from '../GenericComponents/DeleteConfirmationChild';
import { useTranslate } from '@tolgee/react';

const BlockContactElement = ({ item, blocked, blockContact, unblockContact }) => {
  const [openUnblockModal, setOpenUnblockModal] = useState(false);
  const [openBlockModal, setOpenBlockModal] = useState(false);
  const { t } = useTranslate();
  const { theme } = useGenericComponentsStateService();

  return (
    <Warpper >
      <FoundContact >
        <FoundContactAvatar>
          {displayUserAvatar(item)}
          <ProBadgeWrapper>
              {item.is_pro_from_platform ? (
                  theme === "light" ? (
                      <PlatformIconLight />
                  ) : (
                      <PlatformIcon />
                  )
              ) : (
                  item.is_pro && <ProIcon />
              )}
          </ProBadgeWrapper>
        </FoundContactAvatar>

        <p>{item.name}</p>
        
        {blocked ?
          <DeleteConfirmationChild
            open={openUnblockModal}
            setOpen={setOpenUnblockModal}
            variant={"unblock_contact"}
            action={unblockContact}
            item={item}
          >
            <TextButton onClick={() => setOpenUnblockModal(true)}>
              {t('block_contacts.unblock').toUpperCase()}
            </TextButton>
          </DeleteConfirmationChild>
          :
          <DeleteConfirmationChild
            open={openBlockModal}
            setOpen={setOpenBlockModal}
            variant={"block_contact"}
            action={blockContact}
            item={item}
          >
            <TextButton onClick={() => setOpenBlockModal(true)}>
              {t('block_contacts.block')}
            </TextButton>
          </DeleteConfirmationChild>
        }
      </FoundContact>
    </Warpper>
  )
}

export default BlockContactElement

const Warpper = styled.div`
display:block;
z-index:1;
`
const FoundContact = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 0;
  gap: 16px;
  cursor:pointer;
  width:100%;
  overflow:hidden;
  p { 
    overflow:hidden;
   white-space:nowrap;
     text-overflow:ellipsis;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    width: 100%;
  }
`;

const FoundContactAvatar = styled.div`
  display: flex;
  height: 42px;
  width: 42px;
  max-width: 42px;
  min-height: 42px;
  min-width: 42px;
  max-height: 42px;
  border-radius: 100%;
  position: relative;
  overflow: visible;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }

  svg {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

const ProBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -3px;
  right: -3px;
  width: 20px;
  height: 16px;
  
  svg {
    color: ${({ theme }) => theme.loginButton.background};
  }
`;

const TextButton = styled.button`
border:none;
background:none;
font-size: 16px;
font-weight: 400;
line-height: 22px;
color:${({ theme }) => theme.menu.deleteColor};
cursor:pointer;
`